import { type KioskSession } from "../../types";

export function getUsedStampCards(basket: KioskSession["basket"]): string[] {
  const ids = basket.flatMap((item) =>
    item.discounts
      .filter((d) => d.type === "stamp-card")
      .map((d) => d.stampCardRuleId)
  );
  return Array.from(new Set(ids));
}
